import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../services/error.service';
import { HttpMethod } from '../enums/http-method.enum';

export function handleError<T>(operation: string, errorService: ErrorService) {
    return (error: Error): Observable<T> => {
        console.error(`${operation} failed: ${error.message}`);
        return errorService.handleError<T>(`${operation}`)(error);
    };
}

export function handleSuccess<T>(operation: string, errorService: ErrorService) {
    return (result: T): Observable<T> => {
        return errorService.handleSuccess<T>(`${operation}`)(result);
    };
}

export function makeRequest<T>(
    _httpClient: HttpClient,
    method: HttpMethod,
    url: string,
    options: {
        body?: unknown;
        params?: HttpParams | { [param: string]: string | string[] };
        headers?: HttpHeaders | { [header: string]: string | string[] };
        observe?: 'body' | 'response';
        responseType?: 'json' | 'text' | 'blob' | 'arraybuffer';
    } = {},
    errorHandler: (error: Error) => Observable<T>,
    successHandler?: (result: T) => Observable<T>
): Observable<T> {
    return _httpClient
        .request(method, url, {
            body: options.body,
            params: options.params,
            headers: options.headers,
            observe: options.observe || 'body',
            responseType: options.responseType || 'json'
        })
        .pipe(
            tap(result => {
                if (successHandler) {
                    successHandler(result).subscribe();
                }
            }),
            catchError(errorHandler)
        );
}
